import { getMemberships } from '@/store/module/membership/getter/getMemberships.js';

export const getters = {
	getMemberships
};
